import React, { memo } from 'react';
import styles from 'reactApp/ui/UploadList/Item/Item.css';
import { formatDuration } from 'reactApp/utils/duration';

export const RemainTime = memo(
    ({ timeRemain, sizeToUpload, uploadSpeed }: { timeRemain?: number; sizeToUpload?: number; uploadSpeed: number }) => {
        let timeRemainText;

        if (timeRemain) {
            timeRemainText = `Ещё ${formatDuration(timeRemain, true)}`;
        } else if (sizeToUpload && uploadSpeed > 0) {
            timeRemainText = `Ещё ${formatDuration(Math.round(sizeToUpload / 1024 / 1024 / uploadSpeed), true)}`;
        }

        if (timeRemainText) {
            return <div className={styles.remainTime}>{timeRemainText}</div>;
        }

        return null;
    }
);

RemainTime.displayName = 'RemainTime';
